"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var key = 'AIzaSyA5qRKXMuT7sL-Ho5dTgtj44G2dGROy6ho';
var useYouTubeInfo = function (videoId) {
    var _a = react_1.useState({}), video = _a[0], setVideo = _a[1];
    var _b = react_1.useState(false), loadingVideoInfo = _b[0], setLoadingVideoInfo = _b[1];
    var loadVideoInfo = function (_videoId) {
        if (_videoId === undefined || _videoId === null || _videoId.length === 0)
            return;
        var outputPart = 'snippet,statistics';
        var url = 'https://www.googleapis.com/youtube/v3/videos?key=' +
            key +
            '&id=' +
            _videoId +
            '&part=' +
            outputPart;
        setLoadingVideoInfo(true);
        return fetch(url)
            .then(function (response) {
            if (response.status >= 400) {
                throw new Error('Bad response from server');
            }
            setLoadingVideoInfo(false);
            return response.json();
        })
            .then(function (data) {
            if (Array.isArray(data.items) && data.items.length > 0) {
                var item = data.items[0];
                setVideo({
                    videoId: item.id,
                    title: item.snippet.title,
                    thumbnailUrl: item.snippet.thumbnails.default.url,
                    authorName: item.snippet.channelTitle,
                    viewCount: item.statistics.viewCount,
                    publishedAt: item.snippet.publishedAt,
                    tags: item.snippet.tags,
                    videoUrl: "https://www.youtube.com/embed/" + _videoId + "?&autoplay=1&rel=0",
                });
            }
            setLoadingVideoInfo(false);
        })
            .catch(function (error) {
            console.error(error);
            setLoadingVideoInfo(false);
        });
    };
    react_1.useEffect(function () {
        loadVideoInfo(videoId);
    }, [videoId]);
    return {
        video: video,
        loadingVideoInfo: loadingVideoInfo,
        setVideoId: function (_videoId) { return loadVideoInfo(_videoId); },
    };
};
exports.default = useYouTubeInfo;
//# sourceMappingURL=UseYouTubeInfo.js.map